export default __webpack_public_path__ + "static/media/transducer-protector.3db6b421.jpg";